import Swiper from 'swiper';
import {Navigation, Scrollbar} from 'swiper/modules';
import onReady from '@/scripts/modules/on-ready';

onReady(() => {
  const carousels = document.querySelectorAll('.popular-requests-carousel');

  if (0 < carousels.length) {
    Swiper.use([Navigation, Scrollbar])
    carousels.forEach(function (carousel) {
      new Swiper(carousel, {
        slidesPerView: 'auto',
        watchOverflow: true,
        spaceBetween: 20,
        breakpoints: {
          480: {
            spaceBetween: 30,
          },
        },
      });
    });
  }
});
